import axios from 'axios';
import {
  BASE_URL
} from "../../../config/env.js";

export const enterPriseBaseUrl = BASE_URL.TEST_HOST_API;

export const GetMenuListApi=(params)=>{
    let reqUrl='/api/Enterprise/GetMenuList'
    return axios({
        method: 'get',
        url: enterPriseBaseUrl + reqUrl,
        headers:{
            EnterpriseId:''
        }
    })
  }


// WEBPACK FOOTER //
// ./src/js/Api/PermissionApi.js